import React from 'react';
import ReactDOM from 'react-dom/client';
import {HashRouter} from "react-router-dom";//switch は Routesに変わった

import './index.css';
import App from './App';
//コンポーネント
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
//   <React.StrictMode>
     <App />
//   </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
